import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import './registerServiceWorker'
import router from './router'
//import compression from 'compression'

Vue.config.productionTip = false



new Vue({
  vuetify,
  router,
  //compression,
  render: h => h(App)
}).$mount('#app')
